import React from 'react'
import styled from 'styled-components'
const Columns = styled.div`
  columns: 2;
  gap: 2rem;
  @media (orientation: portrait) {
    columns: 1;
  }
  margin-bottom: 2rem;
  margin-top: 2rem;
  p {
    margin-bottom: 0.5em;
    text-indent: 1.5em;
    text-align: justify;
    &:first-of-type {
      text-indent: 0em;
      &::first-letter {
        font-size: 6.6rem;
        line-height: 5.6rem;
        font-weight: 800;
        float: left;
        margin-right: 0.2rem;
      }
    }
  }

  blockquote {
    margin-bottom: 1em;
    margin-top: 1em;
    text-indent: 0;
    text-align: justify;
    font-weight: bold;
  }
`
const Summary = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  padding: 2rem;
  @media (orientation: portrait) {
    padding: 0.5rem;
  }
  @media (max-width: 768px) {
    padding: 0.5rem;
  }
  .list > ul {
    > li {
      position: relative;
      &::before {
        content: ' ';
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='50' fill='black'/%3E%3C/svg%3E");
        width: 0.8em;
        height: 0.8em;
        display: inline-block;
        margin-right: 0.3em;
        position: absolute;
        top: 0.4em;
      }
      > a {
        display: inline-block;
        border-bottom: 1px solid #ccc;
        width: calc(100% - 1.5em);
        &:hover {
          background-color: #f5f5f5;
        }
        margin-left: 1.2em;
      }
      > ul {
        > li {
          margin-left: 1.5rem;
          position: relative;
          > a {
            display: inline-block;
            border-bottom: 1px solid #ccc;
            width: calc(100% - 1.5em);
            &:hover {
              background-color: #f5f5f5;
            }
            margin-left: 1.2em;
          }
          &::before {
            content: ' ';
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='50' fill='black'/%3E%3C/svg%3E");
            width: 0.8em;
            height: 0.8em;
            display: inline-block;
            margin-right: 0.3em;
            position: absolute;
            top: 0.4em;
          }
        }
      }
    }
  }
`

export { Columns, Summary }
